/**
 * @module
 * The pages accounts serves. Every path loads the one `index.html`; the page
 * is picked here, from the pathname.
 */

/**
 * Supabase Auth sends a person here to approve an OAuth client, under its
 * Site URL (`auth.oauth_server.authorization_url_path`).
 */
export const CONSENT_PATH = "/oauth/consent";

/** A client signs out here too, so the single sign-on session ends with it. */
export const SIGN_OUT_PATH = "/sign-out";

export type Page = "consent" | "sign-out" | "home";

export const pageOf = (pathname: string): Page =>
  pathname === CONSENT_PATH
    ? "consent"
    : pathname === SIGN_OUT_PATH
      ? "sign-out"
      : "home";
